export default {
    en: "English",
    fr: "Français",
    de: "Deutsch",
    it: "Italiano",
    es: "Español"
}